<div class="modal-container">
  <div class="header">
    <div class="title">
      <h1>Captar unidade</h1>
    </div>
    <div class="close" mat-dialog-close>
      <img src="../../../assets/svgs/close_btn.svg" alt="close button" />
    </div>
  </div>
  <div class="form-container">
    <form [formGroup]="form" class="form-group">
      <div class="form-control">
        <div class="line-column">
          <div class="type">
            <div class="select">
              <span>Tipo de imóvel / subtipo *</span>
              <app-dropdown-button
                class="cep type"
                [ngClass]="{ borderError: form.get('typeCode').invalid }"
                [label]="titleList ? titleList : 'Selecione'"
                [isOpen]="false"
                [alignRight]="false"
                [icon]="''"
                [closeOnClick]="!closeDropDown"
                [floatOnMobile]="false"
                [newHeight]="true"
                (valueChange)="closeDropDown = $event"
              >
                <div class="list" *ngIf="closeDropDown">
                  <ul class="list-home" *ngFor="let item of listImoveis">
                    <p class="title-home">{{ item.title }}</p>
                    <li class="item-home" *ngFor="let type of item.listItems">
                      <a class="action-home" (click)="assigningValue(type)">{{
                        type.item
                      }}</a>
                    </li>
                  </ul>
                </div>
              </app-dropdown-button>
            </div>
            <div class="error-input" *ngIf="form.get('typeCode').invalid">
              <img
                src="../../../../assets/svgs/i_error.svg"
                class="icon"
                alt="Icon Error"
              />
              <span class="text-error">Campo obrigatório</span>
            </div>
          </div>
          <div class="utility">
            <span>Utilização *</span>
            <div class="fields">
              <lib-input-checkbox
                class="item-action"
                id="residential"
                name="residential"
                label="Residencial"
                formControlName="residential"
              ></lib-input-checkbox>
              <lib-input-checkbox
                class="item-action"
                id="commercial"
                name="commercial"
                label="Comercial"
                formControlName="commercial"
              ></lib-input-checkbox>
            </div>
            <div class="error-input" *ngIf="form.get('commercial').invalid && form.get('residential').invalid">
              <img
                src="../../../../assets/svgs/i_error.svg"
                class="icon"
                alt="Icon Error"
              />
              <span class="text-error">Campo obrigatório</span>
            </div>
          </div>
        </div>
        <div class="line-column" *ngIf="this.code">
          <p class="sub-title">Metragens</p>
        </div>
        <div class="line-column">
          <app-input
            class="input-control"
            id="useful_area"
            [label]="'Área útil *'"
            maxlength="6"
            (input)="removeCaracter($event)"
            *ngIf="fields.useful_area.show"
            formControlName="useful_area"
            [messageError]="'Área útil requerido'"
            [error]="form.get('useful_area').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="total_area"
            [label]="'Área total *'"
            maxlength="6"
            (input)="removeCaracter($event)"
            *ngIf="fields.total_area.show"
            formControlName="total_area"
            [messageError]="'Área total requerido'"
            [error]="form.get('total_area').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="manufacturing_area"
            [label]="'Área Fabril *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.manufacturing_area.show"
            formControlName="manufacturing_area"
            [messageError]="'Área Fabril requerido'"
            [error]="form.get('manufacturing_area').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="carpet_area"
            [label]="'Área de carpete *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.carpet_area.show"
            formControlName="carpet_area"
            [messageError]="'Área de carpete  requerido'"
            [error]="form.get('carpet_area').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="patio_area"
            [label]="'Área de pátio *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.patio_area.show"
            formControlName="patio_area"
            [messageError]="'Área de pátio requerido'"
            [error]="form.get('patio_area').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="right_foot"
            [label]="'Pé direito *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.right_foot.show"
            formControlName="right_foot"
            [messageError]="'Pé direito requerido'"
            [error]="form.get('right_foot').invalid"
            [placeholder]="'m²'"
          >
          </app-input>
        </div>
        <div class="line-column" *ngIf="this.code">
          <p class="sub-title">Características</p>
        </div>
        <div class="line-column">
          <app-input
            class="input-control"
            id="bedroom"
            [label]="'Dormitórios *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.bedroom.show"
            formControlName="bedroom"
            [messageError]="'Dormitórios requerido'"
            [iconPathAlt]="{ path: 'cama', alt: 'cama' }"
            [error]="form.get('bedroom').invalid"
            [placeholder]="'ex.: 02'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="suite"
            [label]="'Suítes *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.suite.show"
            formControlName="suite"
            [messageError]="'Suítes'"
            [iconPathAlt]="{ path: 'cama', alt: 'cama' }"
            [error]="form.get('suite').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="bathroom"
            [label]="'Banheiros *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.bathroom.show"
            formControlName="bathroom"
            [messageError]="'Banheiros requerido'"
            [iconPathAlt]="{ path: 'shower', alt: 'shower' }"
            [error]="form.get('bathroom').invalid"
            [placeholder]="'ex.: 02'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="car_spaces"
            [label]="'Vagas *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.car_spaces.show"
            formControlName="car_spaces"
            [messageError]="'Vagas'"
            [iconPathAlt]="{ path: 'card', alt: 'card' }"
            [error]="form.get('car_spaces').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="living_room"
            [label]="'Salas *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.living_room.show"
            formControlName="living_room"
            [messageError]="'Salas'"
            [iconPathAlt]="{ path: 'cama', alt: 'cama' }"
            [error]="form.get('living_room').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="kitchen_pantry"
            [label]="'Copas *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.kitchen_pantry.show"
            formControlName="kitchen_pantry"
            [messageError]="'Copas'"
            [iconPathAlt]="{ path: 'cama', alt: 'cama' }"
            [error]="form.get('kitchen_pantry').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="kitchen"
            [label]="'Cozinhas *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.kitchen.show"
            formControlName="kitchen"
            [messageError]="'Cozinhas'"
            [iconPathAlt]="{ path: 'cama', alt: 'cama' }"
            [error]="form.get('kitchen').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="docks"
            [label]="'Docas *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.docks.show"
            formControlName="docks"
            [messageError]="'Docas'"
            [iconPathAlt]="{ path: 'card', alt: 'card' }"
            [error]="form.get('docks').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="mezzanine"
            [label]="'Mezaninos *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.mezzanine.show"
            formControlName="mezzanine"
            [messageError]="'Mezaninos'"
            [iconPathAlt]="{ path: 'card', alt: 'card' }"
            [error]="form.get('mezzanine').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
          <app-input
            class="input-control"
            id="number_floors"
            [label]="'Número de Pavimentos *'"
            maxlength="4"
            (input)="removeCaracter($event)"
            *ngIf="fields.number_floors.show"
            formControlName="number_floors"
            [messageError]="'Número de Pavimentos'"
            [iconPathAlt]="{ path: 'card', alt: 'card' }"
            [error]="form.get('number_floors').invalid"
            [placeholder]="'ex.: 01'"
          >
          </app-input>
        </div>
      </div>
    </form>
  </div>
  <div class="footer-container">
    <div class="item">
      <lib-button-tertiary mat-dialog-close>Cancelar</lib-button-tertiary>
      <lib-button-primary class="mrg-15" (click)="sendingDataForm()"
        >Aplicar</lib-button-primary
      >
    </div>
  </div>
</div>
